module.exports = __webpack_public_path__ + "img/insert-03-droit.b6012032.svg";